import { HttpInterceptorFn } from '@angular/common/http';

export const devInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('settings') && req.method === 'PUT') {
    // Do not send request
    // console.warn('DevInterceptor: Preventing PUT request to settings');
    // return of(null);
  }
  return next(req);
};
